import { DateTime } from '@ksyos/date-time';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import type { IReduxState } from '../configureStore';
import { TimeoutModal } from './TimeoutModal';

export function TimeoutWrapped(props: { sessionTimeout: DateTime | undefined }) {
    const [showModal, setShowModal] = useState<boolean>(false);

    useEffect(() => {
        if (props.sessionTimeout) {
            const intervalId = showModalAfterTimeout(props.sessionTimeout);

            return () => {
                window.clearInterval(intervalId);
            };
        }
    }, [props.sessionTimeout]);

    if (showModal) {
        return (
            <>
                <TimeoutModal />
                <span id="timeoutSpan" />
            </>
        );
    } else {
        return <span id="timeoutSpan" />;
    }

    function showModalAfterTimeout(sessionTimeout: DateTime) {
        const sessionTimeoutMilliSeconds = sessionTimeout.diff(DateTime.now(), 'milliseconds');

        const intervalId = window.setTimeout(() => {
            setShowModal(true);
        }, sessionTimeoutMilliSeconds);

        return intervalId;
    }
}

const mapStateToProps = ({ authentication }: IReduxState) => ({
    sessionTimeout: authentication.sessionTimeout,
});

export const Timeout = connect(mapStateToProps)(TimeoutWrapped);
